import type { UiSourceValue } from '@features/reconciliation/enums'
import { getUiSourceTrackingHeaders } from '@features/reconciliation/utils/getUiSourceTrackingHeaders'

import { getRequest, postRequest } from '../../utils'
import { getQueryParamsString } from '../../utils/getQueryParamsString'
import { Bank } from './types/bank'
import { OpenBankingAccount } from './types/openBankingAccount'

export const fetchBanksList = (organizationId: string, countryId: string): Promise<Bank[]> => {
  const paramsString = getQueryParamsString({ countryId })
  return getRequest(`/banking/${organizationId}/banks?${paramsString}`)
}

interface InitiateOpenBankingConnectionProps {
  bankId?: string
  locale: string
  countryCode: string
  organizationId: string
  redirectUrl: string
  uiSource?: UiSourceValue
}

export const initiateOpenBankingConnection = ({
  bankId,
  countryCode,
  locale,
  organizationId,
  redirectUrl,
  uiSource,
}: InitiateOpenBankingConnectionProps): Promise<{ authUrl: string } | null | undefined> => {
  return postRequest(
    `/banking/${organizationId}/connect`,
    {
      culture: locale,
      preselectedCountry: countryCode,
      redirectUrl,
      bankId,
    },
    getUiSourceTrackingHeaders({ uiSource }),
  )
}

interface SyncOpenBankingConnectionProps {
  locale: string
  redirectUrl: string
  organizationId: string
  aiiaBankAccountId: string
}

export const syncOpenBankingConnection = ({
  aiiaBankAccountId,
  locale,
  organizationId,
  redirectUrl,
}: SyncOpenBankingConnectionProps): Promise<{ authUrl?: string }> => {
  return postRequest(`/banking/${organizationId}/accounts/${aiiaBankAccountId}/sync`, {
    culture: locale,
    redirectUrl,
  })
}

export interface FetchOpenBankingAccountsParams {
  withDeleted?: boolean
}

export const fetchOpenBankingAccounts = (
  organizationId: string,
  params: FetchOpenBankingAccountsParams,
): Promise<OpenBankingAccount[]> => {
  const paramsString = getQueryParamsString({
    ...(params.withDeleted ? { withDeleted: params.withDeleted } : {}),
  })

  return getRequest(`/banking/${organizationId}/accounts?${paramsString}`)
}
